import React from "react";
import { Layout } from "../components/Layout";
import { ListProperties } from "../modules/properties/templates/list-properties";

const PageListProperties = () => (
  <Layout>
    <ListProperties />
  </Layout>
);

export default PageListProperties;
